import * as Actions from '../actions';

const initialState = {
	role: [],
	username: null,
	firstName: null,
	lastName: null,
	email: null,
	activities: null,
	verified: false,
	error: null,
	settings: {
		providers: []
	},
	users: []
};

const user = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_USER_DATA: {
			return {
				...state,
				...action.payload
			};
		}
		case Actions.USER_LOGGED_OUT: {
			return initialState;
		}
		case Actions.SET_ACTIVITIES: {
			return {
				...state,
				activities: action.payload
			};
		}
		case Actions.SET_USERS: {
			return {
				...state,
				users: action.payload
			};
		}
		case Actions.SET_ERROR: {
			return {
				...state,
				error: null
			};
		}
		default: {
			return state;
		}
	}
};

export default user;
